/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDlvryProductSpecification containerModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';

export const enum displayStyle {
    accordion = 'accordion',
    table = 'table'
}

export interface IDlvryProductSpecificationConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    displayStyle?: displayStyle;
    className?: string;
    clientRender?: boolean;
}

export interface IDlvryProductSpecificationResources {
    trueValueText: string;
    falseValueText: string;
    productSpecificationFooterText: string;
    additionalTabLabel: string;
    safetyDataSheetLabel: string;
    declarationOfConformityLabel: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IDlvryProductSpecificationProps<T> extends Msdyn365.IModule<T> {
    resources: IDlvryProductSpecificationResources;
    config: IDlvryProductSpecificationConfig;
    slots: {
        productSheet: React.ReactNode[];
        tabs: React.ReactNode[];
    };
}
